var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2321 10.285C14.6665 4.76422 13.3339 2.66803 9.14156 2.75494C7.64838 2.7856 8.00782 1.6738 6.86958 2.09568C5.73135 2.51756 6.70814 3.13491 5.54347 4.08977C2.27839 6.77041 2.57933 9.25023 4.09445 15.1597C4.73261 17.6493 2.55627 17.7714 3.41747 20.184C4.04607 21.9438 8.68002 22.6801 13.5713 20.8652C18.4615 19.0511 21.5474 15.4499 20.9191 13.691C20.0576 11.2772 18.3141 12.6098 17.2321 10.285ZM13.0395 19.3785C8.67244 20.9991 5.08308 20.0465 4.93148 19.6226C4.6702 18.8919 6.34112 16.454 11.3345 14.6017C16.3279 12.7493 19.114 13.4359 19.4051 14.2523C19.5775 14.7336 17.4079 17.7582 13.0395 19.3785ZM11.6366 15.4477C9.35363 16.2948 7.76595 17.2637 6.73993 18.1359C7.46163 18.7929 8.81643 18.9535 10.1665 18.4523C11.8849 17.8153 12.9396 16.3519 12.522 15.1839C12.5178 15.1698 12.5099 15.1577 12.5045 15.1434C12.2233 15.2367 11.9344 15.3366 11.6366 15.4477Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.e312c302.svg";
export { ForwardRef as ReactComponent };